export const CREATIVE_BLOCK = 'creative';
export const TEXT_BLOCK = 'text';
export const DYNAMIC_TABLE_BLOCK = 'dynamic_table';
export const LINK_BLOCK = 'link';
export const BUTTON_BLOCK = 'button';
export const STANDALONE_BLOCK = 'parent';
export const STATIC_TABLE_BLOCK = 'static_table';
export const HTML_BLOCK = 'html';

export const COMPLEX_BLOCK_TYPE = [CREATIVE_BLOCK, TEXT_BLOCK, DYNAMIC_TABLE_BLOCK, STANDALONE_BLOCK, LINK_BLOCK, BUTTON_BLOCK, STATIC_TABLE_BLOCK, HTML_BLOCK];
export const FIXED_HEIGHT_BLOCKS = [CREATIVE_BLOCK];
export const OVERFLOWING_BLOCK_TYPES = [TEXT_BLOCK, STATIC_TABLE_BLOCK];
export const DESIGN_FIXED_HEIGHT_BLOCKS = [CREATIVE_BLOCK];
export const HEADER = 'header';
export const FOOTER = 'footer';
export const PAGE_NUMBER = 'pageNumber';
export const REPLACE_FLOW = 'replaceFlow';
export const COMPLEX_EMAIL = 'complexEmail';
export const REUSABLE_SECTION = 'reusableSection';
export const REUSABLE_FLOW = 'reusableFlow';
export const TOC = 'toc';
export const TABLE_OF_CONTENTS = 'TABLE OF CONTENTS';
export const ENVELOPE_ADDRESS_BLOCK = 'address';

export const RESIZE_HANDLE = ['s'];
export const FOOTER_HANDLE = ['n'];
export const dummyCallback = () => {};
export const ELEMENTS = 'elements';

export const TEXT_ELEMENT = 'text';
export const IMAGE_ELEMENT = 'image';
export const SVG_ELEMENT = 'svg';
export const BARCODE_ELEMENT = 'barcode';
export const FILLABLE_ELEMENT = 'fillable';
export const STATIC_TABLE_ELEMENT = 'static_table';
export const PERFECTDOC_RELATIONSHIP = 'perfectdoc-relationship';

export const ApprovalModal = 'ApprovalModal';
export const JOBQueueModal = 'JobQueueModal';
export const JobProcessingModal = 'JobProcessingModal';
export const PrintingModal = 'PrintingModal';
export const PrintingQueue = 'PrintingQueue';
export const PrintingCenter = 'PrintingCenter';
export const ControlCenter = 'ControlCenter';

export const FILLABLE_TEXT_INPUT_TYPE = 'text_input';
export const OPTIONS_KEY = 'formOptions';
export const FIELD_NAME_KEY = 'fieldName';
export const READ_ONLY_KEY = 'isReadOnly';
export const INPUT_TEXT_ELEMENT_OPTIONS = {
  MULTILINE_KEY: 'isMultiLine',
  MAX_CHARACTERS_KEY: 'maxCharacters',
};

export const FILLABLE_SIGNATURE_TYPE = 'signature';
export const FILLABLE_COMBO_BOX_TYPE = 'combobox';
export const FILLABLE_CHECKBOX_TYPE = 'checkbox';
export const FILLABLE_RADIO_BUTTON_TYPE = 'radiobutton';
export const FILLABLE_CHECKBOX_GROUP_TYPE = 'checkboxgroup';
export const FILLABLE_RADIO_BUTTON_GROUP_TYPE = 'radiobuttongroup';
export const FILLABLE_COMBOBOX_GROUP_TYPE = 'combobox_group';
export const CHECK_TYPE_KEY = 'checkType';
export const IS_VARIABLE_KEY = 'isVariable';
export const LINK_DISPLAY_TEXT = 'displayText';
export const GROUP_NAME_KEY = 'groupName';
export const IS_CHECKED_KEY = 'isChecked';
export const ALL_FILLABLE_ELEMENTS = [
  FILLABLE_TEXT_INPUT_TYPE,
  FILLABLE_COMBO_BOX_TYPE,
  FILLABLE_SIGNATURE_TYPE,
  FILLABLE_CHECKBOX_TYPE,
  FILLABLE_RADIO_BUTTON_TYPE,
  FILLABLE_COMBOBOX_GROUP_TYPE
];

export const FULLY_DYNAMIC_FILLABLE_ELEMENTS = [
  FILLABLE_COMBOBOX_GROUP_TYPE,
  FILLABLE_CHECKBOX_GROUP_TYPE,
  FILLABLE_RADIO_BUTTON_GROUP_TYPE,
];
export const UNSUPPORTED_REPEAT_ELEMENTS = [
  FILLABLE_SIGNATURE_TYPE,
  'textbox',
  FILLABLE_COMBO_BOX_TYPE,
  FILLABLE_CHECKBOX_TYPE,
  FILLABLE_RADIO_BUTTON_TYPE,
];

export const COMPLEX_DOCUMENT_PAGE_WRAPPER = 'complex-page-wrapper';
export const TEXT_DEBOUNCE_TIME_OUT = 300;

export const ELEMENT_TYPES = {
  CHART: 'chart',
};

export const COMPLEX_DOCUMENT_VERSION = {
  DRAFT: 'draft',
  QA_READY: 'qaready',
  QA_COMPLETE: 'qacomplete',
  PUBLISHED: 'published',
  SANDBOX: 'sandbox',
  LIVE: 'live',
  REJECTED: 'rejected',
}

export const versionsApiMap = {
  draft: 'draft',
  qaready: 'sandbox',
  published: 'live',
};

export const DESIGN_TYPE = {
  DOCUMENT: 'document',
  FLOW: 'flow',
  BLOCK: 'block'
}

export const MAX_INACTIVE_TIME = 30; // Minutes

export const LINK_BLOCK_CONTENT_TYPES = [
  'FACEBOOK',
  'LINKEDIN',
  'INSTAGRAM',
  'TWITTER',
  'WHATSAPP',
];

export const ACCESSIBLE_ELEMENTS = [
  TEXT_ELEMENT,
  IMAGE_ELEMENT,
  BARCODE_ELEMENT,
  ELEMENT_TYPES.CHART,
  SVG_ELEMENT,
  STATIC_TABLE_ELEMENT
];

export const BARCODE_39 = 'code39';

export const CREATIVE_BLOCK_ELEMENT_TYPES = [TEXT_ELEMENT, SVG_ELEMENT, BARCODE_ELEMENT, IMAGE_ELEMENT, ELEMENT_TYPES.CHART, STATIC_TABLE_ELEMENT, FILLABLE_ELEMENT];
export const DOCUMENT_PREVIEW_ERROR_CODES = [3105, 503, 9999, 2425, 2426, 2605, 5604];
export const EMPTY_ARRAY = [];

export const CHANNELS = {
  PRINT: 'print',
  EMAIL: 'email',
}


export const envs = ['draft', 'sandbox', 'live'];

export const SUPPORTED_ENVELOPE_TYPES = { // all measurements in mm
  C4: {
    x: 26,
    y: 67,
    width: 59,
    height: 33,
    rotate: 0,
    padding: [2, 2, 2, 2]
  },
  C5: {
    x: 22,
    y: 52,
    width: 59,
    height: 33,
    rotate: 0,
    padding: [2, 2, 2, 2]
  },
  DL: {
    x: 23,
    y: 30,
    width: 59,
    height: 33,
    rotate: 0,
    padding: [2, 2, 2, 2]
  }
}
